(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('AgendaListsDeletedController', ['SharedAgendaService', 'AgendaOverviewService', AgendaListsDeletedControllerFn]);

    /* controller for agenda list - deleted */
    function AgendaListsDeletedControllerFn(SharedAgendaService, AgendaOverviewService) {
        var vm = this;

        // current agenda 
        vm.agenda = null;

        activate();

        // activation work 
        function activate() {
            // allow shared agenda-switch
            SharedAgendaService.allow();

            // current agenda
            vm.agenda = SharedAgendaService.data.currentAgenda;

        }


    }
})();